// extracted by mini-css-extract-plugin
export default {"wrapper":"ccd066d893f6e7e3","title":"_38d248b9a5160ca2"};